<div class="scene-bank-shell">
    <header class="scene-bank-header">
        <div>
            <h2 mat-dialog-title>Choose a scene layout</h2>
            <p>Pick a category, then choose the layout that fits this scene.</p>
        </div>
        <button type="button" class="close-button" aria-label="Close scene layouts" (click)="closeDialog()">
            <mat-icon>close</mat-icon>
        </button>
    </header>

    <div
        *ngIf="design && personalizedDynamics && visibleCategories.length > 0 && activeCategory"
        class="scene-bank-body">
        <nav class="category-navigation" aria-label="Scene layout categories">
            <button
                *ngFor="let category of visibleCategories"
                type="button"
                class="category-nav-item"
                [class.active]="category === activeCategory"
                [attr.aria-pressed]="category === activeCategory"
                (click)="selectCategory(category)">
                <span>{{ category.name }}</span>
                <span class="category-count">{{ category.compositionsAndStagePositions.length }}</span>
            </button>
        </nav>

        <section class="category-content" aria-labelledby="active-category-title">
            <header class="category-content-header">
                <div>
                    <h3 id="active-category-title">{{ activeCategory.name }}</h3>
                    <p>{{ activeCategory.compositionsAndStagePositions.length }} layouts</p>
                </div>
            </header>

            <p *ngIf="hasCompositionLoadErrors" class="load-warning" role="status">
                Some layouts couldn’t be loaded. The available layouts are shown below.
            </p>

            <div class="scene-grid">
                <button
                    *ngFor="let sceneComposition of activeCategory.compositionsAndStagePositions"
                    type="button"
                    class="composition-cell"
                    [class.selected]="sceneComposition.composition._id === chosenComposition?._id"
                    [class.aspect-169]="aspectRatio === AspectRatioEnum._16x9"
                    [class.aspect-11]="aspectRatio === AspectRatioEnum._1x1"
                    [class.aspect-916]="aspectRatio === AspectRatioEnum._9x16"
                    [attr.aria-pressed]="sceneComposition.composition._id === chosenComposition?._id"
                    (click)="chooseComposition(sceneComposition.composition)">
                    <span class="composition-preview">
                        <span class="composition-area" [style.aspect-ratio]="aspectRatio">
                            <app-silhouette
                                *ngIf="sceneComposition.stagePositions.length > 0"
                                [stagePositions]="sceneComposition.stagePositions">
                            </app-silhouette>

                            <dynamic-lottie
                                [config]="{
                                    layout: sceneComposition.composition.layouts[0],
                                    dynamicLottieChanges: personalizedDynamics,
                                }">
                            </dynamic-lottie>
                        </span>
                    </span>
                    <span class="composition-name">{{ sceneComposition.composition.name }}</span>
                    <mat-icon class="selected-indicator" aria-hidden="true">check</mat-icon>
                </button>
            </div>
        </section>
    </div>

    <div *ngIf="isLoadingCompositions" class="scene-bank-empty">
        <mat-icon>view_quilt</mat-icon>
        <p>Loading scene layouts…</p>
    </div>

    <div
        *ngIf="!isLoadingCompositions && visibleCategories.length === 0"
        class="scene-bank-empty"
        role="status"
        aria-live="polite">
        <mat-icon>view_quilt</mat-icon>
        <p *ngIf="!hasCompositionLoadErrors">No scene layouts are available for this project.</p>
        <p *ngIf="hasCompositionLoadErrors">Scene layouts couldn’t be loaded. Close this window and try again.</p>
    </div>

    <footer class="buttons-area" mat-dialog-actions>
        <div class="selection-status" aria-live="polite">
            <p *ngIf="confirmationError" class="confirmation-error">{{ confirmationError }}</p>
            <p *ngIf="!confirmationError" class="selection-summary">
                <ng-container *ngIf="chosenComposition; else noSelection">
                    <span>Selected</span>
                    {{ chosenComposition.name }}
                </ng-container>
                <ng-template #noSelection>Select a layout to continue</ng-template>
            </p>
        </div>
        <div class="dialog-actions">
            <button type="button" mat-button (click)="closeDialog()">Cancel</button>
            <button
                type="button"
                color="primary"
                mat-raised-button
                [disabled]="!chosenComposition || isLoadingNewScene"
                [class.button-loading-spinner]="isLoadingNewScene"
                [attr.aria-busy]="isLoadingNewScene"
                (click)="onConfirmClickedAsync()">
                <span>{{ isLoadingNewScene ? 'Using layout…' : 'Use layout' }}</span>
            </button>
        </div>
    </footer>
</div>
